import { CircleCheck, Info, LoaderCircle, OctagonX, TriangleAlert } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps, toast } from 'sonner';

/**
 * Toast host; mount once in the app shell. Use `toast.success('Saved')`,
 * `toast.error(problem.title)`, `toast.promise(...)` anywhere (re-exported here).
 */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      richColors={false}
      icons={{
        success: <CircleCheck className="size-4 text-success" />,
        info: <Info className="size-4 text-info" />,
        warning: <TriangleAlert className="size-4 text-warning" />,
        error: <OctagonX className="size-4 text-danger" />,
        loading: <LoaderCircle className="size-4 animate-spin text-fg-muted" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group flex w-full items-center gap-3 rounded-lg border border-border bg-surface-raised p-4 text-fg shadow-lg',
          title: 'text-sm font-medium',
          description: 'text-sm text-fg-muted',
          actionButton: 'rounded-md bg-accent-solid px-3 py-1 text-xs font-medium text-accent-fg',
          cancelButton: 'rounded-md bg-surface-sunken px-3 py-1 text-xs font-medium text-fg-muted',
          closeButton: 'border-border bg-surface-raised text-fg-muted hover:bg-surface-sunken',
        },
      }}
      {...props}
    />
  );
}

export { toast };
